"use client";
//#region packages/@mantine/core/src/core/utils/get-base-value/get-base-value.ts
function getBaseValue(value) {
	if (typeof value === "object" && value !== null) {
		if ("base" in value) return value.base;
		return;
	}
	return value;
}
//#endregion
export { getBaseValue };

//# sourceMappingURL=get-base-value.mjs.map